import React from 'react'
import { useLocation, useNavigate } from "react-router-dom";
function Navbar() {

    const navigate = useNavigate();
    const location = useLocation();
    const moveToHome = (e) => {
        e.preventDefault();
        navigate("/Board-dashboard");
    }
    const moveToPendingVerification = (e) => {
        e.preventDefault();
        navigate("/Board-pending-verification");
      }
      const moveToApprovedPayments = (e) => {
        e.preventDefault();
        navigate("/Board-approved-payment");
      }
      const moveToRejectedPayments = (e) => {
        e.preventDefault();
        navigate("/Board-rejected-payment");
      }
      const moveToPendingPayments = (e) => {
        e.preventDefault();
        navigate("/Board-pending-payment");
      }
      const moveToBoardReports = (e) => {
        e.preventDefault();
        navigate("/Board-reports");
      }
      const moveToCentreLogin = (e) => {
        e.preventDefault();
        navigate("/centre-login");
      }
      const moveToUploadNotice = (e) => {
        e.preventDefault();
        navigate("/upload-notice");
      }
    return (
        <nav class="pc-sidebar">
            <div class="navbar-wrapper">
                <div class="m-header">
                    <a href="" onClick={moveToHome} class="b-brand text-primary mbose-section">
                        <img src="../assets/images/MBOSE.png" class="logo-md" alt="logo" height={50} />
                        <h3 className='mbose-text'>MBOSE</h3>
                    </a>
                </div>
                <div class="navbar-content">
                    <ul class="pc-navbar">
                        <li className={`pc-item ${location.pathname === "/Board-dashboard" ? "active" : ""}`} >
                            <a href="" onClick={moveToHome} className="pc-link" style={{display:'flex'}}>
                                <div className="pc-micon"><i className="ti ti-dashboard"></i></div>
                                <div className="pc-mtext">Dashboard</div>
                            </a>
                        </li>

                        <li class="pc-item pc-caption">
                            <label>Pages</label>
                            <i class="ti ti-dashboard"></i>
                        </li>
                        <li className={`pc-item ${location.pathname === "/Board-pending-verification" ? "active" : ""}`}>
                            <a href="" onClick={moveToPendingVerification} className="pc-link" style={{display:'flex'}}>
                                <div class="pc-micon"><i className="fas fa-clock"></i></div>
                                <div class="pc-mtext">Total Payments Pending for Verification</div>
                            </a>
                        </li>
                        <li className={`pc-item ${location.pathname === "/Board-approved-payment" ? "active" : ""}`}>
                            <a href="" onClick={moveToApprovedPayments} className="pc-link" style={{display:'flex'}}>
                                <div class="pc-micon"><i class="fa fa-check"></i></div>
                                <div class="pc-mtext">Total Approved Payments</div>
                            </a>
                        </li>
                        <li className={`pc-item ${location.pathname === "/Board-rejected-payment" ? "active" : ""}`}>
                            <a href="" onClick={moveToRejectedPayments} className="pc-link" style={{display:'flex'}}>
                                <div class="pc-micon"><i class="fa fa-times"></i></div>
                                <div class="pc-mtext">Total Rejected Payments</div>
                            </a>
                        </li>
                        <li className={`pc-item ${location.pathname === "/Board-pending-payment" ? "active" : ""}`}>
                            <a href="" onClick={moveToPendingPayments}  className="pc-link" style={{display:'flex'}}>
                            <div class="pc-micon"><i class="fa fa-bars-progress"></i></div>
                                <div class="pc-mtext">Challan Pending for Board Submission</div>
                            </a>
                        </li>
                        <li className={`pc-item ${location.pathname === "/Board-reports" ? "active" : ""}`}>
                            <a href="" onClick={moveToBoardReports}  className="pc-link" style={{display:'flex'}}>
                            <div class="pc-micon"><i class="fa fa-file-alt"></i></div>
                                
                                <div class="pc-mtext">Board Reports</div>
                            </a>
                        </li>
                        <li className={`pc-item ${location.pathname === "/centre-login" ? "active" : ""}`}>
                            <a href="" onClick={moveToCentreLogin}  className="pc-link" style={{display:'flex'}}>
                                <div class="pc-micon"><i class="fa fa-university"></i></div>
                                <div class="pc-mtext">Centre Login</div>
                            </a>
                        </li>
                        <li className={`pc-item ${location.pathname === "/upload-notice" ? "active" : ""}`}>
                            <a href="" onClick={moveToUploadNotice}  className="pc-link" style={{display:'flex'}}>
                                <div class="pc-micon"><i class="fa fa-file"></i></div>
                                <div class="pc-mtext">Upload Notice</div>
                            </a>
                        </li>
                        {/* <li class="pc-item">
                    <a href="../elements/bc_color.html" class="pc-link">
                        <span class="pc-micon"><i class="ti ti-color-swatch"></i></span>
                        <span class="pc-mtext">Color</span>
                    </a>
                </li>
                <li class="pc-item">
                    <a href="../elements/icon-tabler.html" class="pc-link">
                        <span class="pc-micon"><i class="ti ti-plant-2"></i></span>
                        <span class="pc-mtext">Icons</span>
                    </a>
                </li>

                <li class="pc-item pc-caption">
                    <label>Pages</label>
                    <i class="ti ti-news"></i>
                </li>
                <li class="pc-item">
                    <a href="../pages/login.html" class="pc-link">
                        <span class="pc-micon"><i class="ti ti-lock"></i></span>
                        <span class="pc-mtext">Login</span>
                    </a>
                </li>
                <li class="pc-item">
                    <a href="../pages/register.html" class="pc-link">
                        <span class="pc-micon"><i class="ti ti-user-plus"></i></span>
                        <span class="pc-mtext">Register</span>
                    </a>
                </li>

                <li class="pc-item pc-caption">
                    <label>Other</label>
                    <i class="ti ti-brand-chrome"></i>
                </li>
                <li class="pc-item pc-hasmenu">
                    <a href="#!" class="pc-link"><span class="pc-micon"><i class="ti ti-menu"></i></span><span class="pc-mtext">Menu
                        levels</span><span class="pc-arrow"><i data-feather="chevron-right"></i></span></a>
                    <ul class="pc-submenu">
                        <li class="pc-item"><a class="pc-link" href="#!">Level 2.1</a></li>
                        <li class="pc-item pc-hasmenu">
                            <a href="#!" class="pc-link">Level 2.2<span class="pc-arrow"><i data-feather="chevron-right"></i></span></a>
                            <ul class="pc-submenu">
                                <li class="pc-item"><a class="pc-link" href="#!">Level 3.1</a></li>
                                <li class="pc-item"><a class="pc-link" href="#!">Level 3.2</a></li>
                                <li class="pc-item pc-hasmenu">
                                    <a href="#!" class="pc-link">Level 3.3<span class="pc-arrow"><i data-feather="chevron-right"></i></span></a>
                                    <ul class="pc-submenu">
                                        <li class="pc-item"><a class="pc-link" href="#!">Level 4.1</a></li>
                                        <li class="pc-item"><a class="pc-link" href="#!">Level 4.2</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li class="pc-item pc-hasmenu">
                            <a href="#!" class="pc-link">Level 2.3<span class="pc-arrow"><i data-feather="chevron-right"></i></span></a>
                            <ul class="pc-submenu">
                                <li class="pc-item"><a class="pc-link" href="#!">Level 3.1</a></li>
                                <li class="pc-item"><a class="pc-link" href="#!">Level 3.2</a></li>
                                <li class="pc-item pc-hasmenu">
                                    <a href="#!" class="pc-link">Level 3.3<span class="pc-arrow"><i data-feather="chevron-right"></i></span></a>
                                    <ul class="pc-submenu">
                                        <li class="pc-item"><a class="pc-link" href="#!">Level 4.1</a></li>
                                        <li class="pc-item"><a class="pc-link" href="#!">Level 4.2</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li class="pc-item">
                    <a href="../other/sample-page.html" class="pc-link">
                        <span class="pc-micon"><i class="ti ti-brand-chrome"></i></span>
                        <span class="pc-mtext">Sample page</span>
                    </a>
                </li> */}
                    </ul>


                </div>
            </div>
        </nav>
    )
}

export default Navbar